import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { setPasswordSchema } from "../../Schema/authSchema";
import { useMutation } from "react-query";
import { resetPassword } from "../../Services/Auth";
import { Error, Success } from "../../Components/Modal";
import Button from "../../Components/Button";
import "../../styles/PremiumLogin.css";

export default function SetPassword() {
  const [showPassword, setShowPassword] = useState({
    newPassword: false,
    confirmPassword: false,
  });
  const navigate = useNavigate();
  const [apiData, setApiData] = useState({
    email: localStorage.getItem("email"),
    code: localStorage.getItem("code"),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(setPasswordSchema),
  });

  const { mutate, isLoading } = useMutation((data) => resetPassword(data), {
    retry: false,
    onSuccess: (res) => {
      localStorage.removeItem("email");
      localStorage.removeItem("code");
      Success("Reset Password", res.data?.message);
      navigate("/superadmin");
    },
    onError: (err) => {
      // console.log("resetPassword Err: ", err);
      Error(err.response.data?.message);
    },
  });

  const submit = (data) => {
    console.log(data, "data");

    mutate({
      email: apiData?.email,
      password: data?.confirmPassword,
      otp: apiData?.code,
    });
  };

  console.log(errors);

  return (
    <section className="loginPage">
      <div className="container-fluid p-0">
        <div className="row g-0 align-items-center">
          <div className="col-lg-6 px-4 loginBgLeft d-none d-lg-flex flex-column justify-content-center">
            <div className="loginBgLeftPattern" style={{ backgroundImage: "url('/images/loginLeftContentBG.png')" }} />
            <div className="loginLeftContent">
              <img
                src="images/loginLogo.png"
                alt="MUVRRS Logo"
                className="img-fluid loginLogo"
              />
              <p className="loginLeftTagline">
                Recover your access. <strong>Safe and secure.</strong>
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 loginBgRight">
            <div className="loginCard">
              <div className="text-center d-block d-lg-none mb-4">
                <img
                  src="images/loginLogo.png"
                  alt="MUVRRS Logo"
                  className="loginLogo img-fluid"
                />
              </div>
              <div className="formBox">
                <div className="formHeading mb-4">
                  <h2>Password Recovery</h2>
                  <p>Choose a new password for your account</p>
                </div>
                <form
                  className="py-2"
                  onSubmit={handleSubmit(submit)}
                >
                  <div className="form-field">
                    <label htmlFor="newPassword" className="siteLabel">
                      New Password<span className="text-danger">*</span>
                    </label>
                    <div className="input-icon-wrapper">
                      <i className="fas fa-lock input-icon-left" />
                      <input
                        type={showPassword.newPassword ? "text" : "password"}
                        className="siteInput passInput"
                        placeholder="Enter New Password"
                        id="newPassword"
                        {...register("newPassword")}
                      />
                      <button
                        type="button"
                        className="passDisplay"
                        onClick={() =>
                          setShowPassword({
                            ...showPassword,
                            newPassword: !showPassword.newPassword,
                          })
                        }
                      >
                        <i
                          className={
                            showPassword.newPassword
                              ? "fas fa-eye"
                              : "fas fa-eye-slash"
                          }
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                    {errors?.newPassword && (
                      <span className="text-danger">
                        {errors?.newPassword?.message}
                      </span>
                    )}
                  </div>
                  <div className="form-field">
                    <label htmlFor="confirmPassword" className="siteLabel">
                      Confirm Password<span className="text-danger">*</span>
                    </label>
                    <div className="input-icon-wrapper">
                      <i className="fas fa-lock input-icon-left" />
                      <input
                        type={
                          showPassword.confirmPassword ? "text" : "password"
                        }
                        className="siteInput passInput"
                        placeholder="Enter Confirm Password"
                        id="confirmPassword"
                        {...register("confirmPassword")}
                      />
                      <button
                        type="button"
                        className="passDisplay"
                        onClick={() =>
                          setShowPassword({
                            ...showPassword,
                            confirmPassword: !showPassword.confirmPassword,
                          })
                        }
                      >
                        <i
                          className={
                            showPassword.confirmPassword
                              ? "fas fa-eye"
                              : "fas fa-eye-slash"
                          }
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                    {errors?.confirmPassword && (
                      <span className="text-danger">
                        {errors?.confirmPassword?.message}
                      </span>
                    )}
                  </div>
                  <div className="form-field mt-4 text-center">
                    <Button
                      type="submit"
                      className="siteBtn w-100 mb-3"
                      loading={isLoading}
                    >
                      Update
                    </Button>
                    <Link
                      to="/superadmin"
                      className="siteBtn2 w-100 mb-3"
                      onClick={() => {
                        localStorage.removeItem("email");
                        localStorage.removeItem("code");
                      }}
                    >
                      Back To Sign In
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
